import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c71d632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "emojis-list"
}
const _hoisted_2 = { class: "emojis-current" }
const _hoisted_3 = ["title", "data-emoji"]
const _hoisted_4 = {
  key: 1,
  class: "emoji-current-single-num"
}
const _hoisted_5 = {
  key: 0,
  class: "emoji-popup-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emoji-title" }, "Pick Your Reaction", -1))
const _hoisted_7 = { class: "emojis" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "emoji-split" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["emoji-reaction-container", { mobile: _ctx.isMobile }])
  }, [
    (_ctx.emojiKeysNum === 0 && _ctx.singleMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["emoji-reaction-button", { 'emoji-reaction-button-hover': _ctx.showEmojis }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojis && _ctx.toggleEmojis(...args)))
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.emojiKeysNum > 0 && !_ctx.singleMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(["emoji-list-button", { 'emoji-list-button-hover': _ctx.showEmojis }]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojis && _ctx.toggleEmojis(...args)))
          }, null, 2),
          _createElementVNode("span", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojis, (names, emoji) => {
              return (_openBlock(), _createElementBlock("span", {
                key: emoji,
                class: "emoji-current-single"
              }, [
                (names.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["emoji-single current-single-pic", [
                            _ctx.emoji2class[emoji],
                            emoji == _ctx.lastEmoji ? 'emojianimate' : '',
                        ]]),
                      "data-uk-tooltip": "{delay: 500, animation: true, offset: 10}",
                      title: _ctx.getEmojiTooltip(names),
                      "data-emoji": _ctx.emoji2class[emoji],
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                    }, null, 10, _hoisted_3))
                  : _createCommentVNode("", true),
                (names.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(names.length || 0), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.showEmojis)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["emojis-popup", {
                        single: _ctx.emojiKeysNum === 0,
                        multiple: _ctx.emojiKeysNum > 0,
                    }])
              }, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "thumsup",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "thumsdown",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "smile",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "tada",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "frown",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "heart",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  }),
                  _hoisted_8,
                  _createElementVNode("span", {
                    class: "emoji-single",
                    "data-emoji": "kiwi",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.processReaction && _ctx.processReaction(...args)))
                  })
                ])
              ], 2)
            ])), [
              [_directive_click_outside, _ctx.hideEmojiPopup]
            ])
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ], 2))
}